export default "__VITE_ASSET__BzAKvs4r__"